module.exports = __webpack_public_path__ + "static/media/img2-1.05f64efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/agave/nutricheck_foliar/P/img2-1.png
// module id = 1052
// module chunks = 3